import { getAmericanTime } from '@helpers/getAmericanTimezone';
import { GetBillingAccountResponseSubscriptionDto, PrismaSubscriptionProductDto } from 'app/API';

import { Wrapper } from './styles/Wrapper';

type TProps = {
  onButtonClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  subscription: GetBillingAccountResponseSubscriptionDto;
  plan: PrismaSubscriptionProductDto;
  className?: string;
};

export const CanceledCard = ({ plan, subscription, className = '' }: TProps) => {
  const planName = plan?.name.replace('AutoScriptOne ', '');
  const endDate = subscription.cancelAt ? getAmericanTime(subscription.cancelAt) : 'the end of the billing period';

  return (
    <Wrapper className={className}>
      <div className="content">
        <h2 className="as-one">Subscription</h2>
        <p className="description">
          {planName} has been canceled and will expire at {endDate}.
        </p>
      </div>

      {/* {onButtonClick ? (*/}
      {/*  <div className="buttonContainer">*/}
      {/*    <button onClick={onButtonClick}>Choose Subscription</button>*/}
      {/*  </div>*/}
      {/* ) : null}*/}
    </Wrapper>
  );
};
